import React, { useState, useEffect, useCallback } from "react";
import axios from 'axios';
import Preloader from '../components/Preloader'

const Feature = () => {
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const apiUrl = apiBaseUrl+`feature`;
  const [data, setData] = useState([]);    
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchPagedata = async () => {
        setLoading(true);
        try {
            const [featureRes] = await Promise.all([
            axios.get(apiUrl),
             ]);
            setData(featureRes.data);
        } catch (error) {
            console.error("Error fetching data:", error);
        };
        setLoading(false);
    }
    fetchPagedata();
  }, []); 

  return (
    <>
        { loading && <Preloader />}
        <section class="feature-one">
            <div class="container">
                <ul class="feature-one__list">
                    <li class="feature-one__item">
                        <div class="feature-one__item__img">
                            <img src="assets/images/shapes/feature-1-1.png" alt="growim" />
                        </div>
                        <p class="feature-one__item__text">
                            <span>{ data?.title1 }</span> { data?.description1 }
                        </p>
                    </li>
                    <li class="feature-one__item">
                        <div class="feature-one__item__img">
                            <img src="assets/images/shapes/feature-1-2.png" alt="growim" />
                        </div>
                        <p class="feature-one__item__text">
                            <span>{ data?.title2 }</span> { data?.description2 }
                        </p>
                    </li>
                </ul>
            </div>
        </section>
    </>
  )
}

export default Feature